<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" md="12">
        <b-card>
          <div slot="header">
            <div class="row">
              <div class="col-sm-6">
                <i class="fa fa-info-circle" style="color: #20a8d8;"></i> I2OC
                Process Flow Chart
              </div>
              <div class="col-sm-4"></div>
              <div class="col-sm-2">
                <button
                  id="btn_manual"
                  type="button"
                  class="btn btn-pill btn-primary"
                  style="height: 35px; margin-top: 1px;"
                  @click.prevent="download_manual"
                >
                  Download Manual
                </button>
              </div>
            </div>
          </div>

          <form-wizard color="#20a8d8">
            <h5 slot="title" style="display: none;"></h5>
            <tab-content title="Basic Setup" icon="fa fa-info-circle">
              <div id="wrapper">
                <div id="container">
                  <ol class="organizational-chart">
                    <li>
                      <div class="opp">
                        <h4 style="color: #29363dc2;">
                          <i class="fa fa-info-circle"></i> Basic Setup
                        </h4>
                      </div>
                      <ol style="padding-right: 10%; padding-left: 10%;">
                        <li style="width: 27%;">
                          <div class="opp">
                            <a class="opp" href="#"
                              ><h5 style="color: #29363dc2;">
                                <i class="fa fa-building"></i> Company Profile
                              </h5></a
                            >
                          </div>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/companyinfo/Registration"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-pencil"></i> Shop / Company
                                    Registration
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/companyinfo/Shop"
                                  ><h5 style="color: #29363dc2;">
                                    <i
                                      style="color: rgba(41, 54, 61, 0.76);"
                                      class="fa fa-plus"
                                    ></i>
                                    Add Multiple Shops
                                  </h5></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                        <li>
                          <div class="opp">
                            <a href="#"
                              ><h5 style="color: #29363dc2;">
                                <i class="fa fa-shield"></i> Roles
                              </h5></a
                            >
                          </div>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/Definesecurity/User">
                                  <h5 style="color: #29363dc2;">
                                    <i class="fa fa-user-plus"></i> Add User
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/Definesecurity/Role"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-refresh"></i> Add Update
                                    Role
                                  </h5></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </tab-content>

            <tab-content title="Setup" icon="fa fa-cogs">
              <div id="wrapper">
                <div id="container">
                  <ol class="organizational-chart">
                    <li>
                      <div class="opp">
                        <h4 style="color: #29363dc2;">
                          <i class="fa fa-cogs"></i> Setup
                        </h4>
                      </div>
                      <ol style="width: 42%; margin-left: 29%;">
                        <li>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/setup/addupdatecategory"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-list-alt"></i> Product
                                    Category
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/setup/addupdatebrand"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-bold"></i> Add Brand
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/setup/addupdateunit"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-file-text-o"></i> Add Unit
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/setup/addupdatevariant"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-list-ol"></i> Add Variant
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/setup/taxdetails/hsn">
                                  <h5 style="color: #29363dc2;">
                                    <i class="fa fa-percent"></i> Add HSN
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/setup/taxdetails/hsnrate">
                                  <h5 style="color: #29363dc2;">
                                    <i class="fa fa-percent"></i> Add Tax
                                    Details
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/setup/addupdateproduct"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-shopping-cart"></i> Add
                                    Product
                                  </h5></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </tab-content>

            <tab-content title="Purchase" icon="fa fa-shopping-cart">
              <div id="wrapper">
                <div id="container">
                  <ol class="organizational-chart">
                    <li>
                      <div class="opp">
                        <h4 style="color: #29363dc2;">
                          <i class="fa fa-shopping-cart"></i> Purchase
                        </h4>
                      </div>
                      <ol style="width: 42%; margin-left: 29%;">
                        <li>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/purchase/supplier/add"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-user-plus"></i> Add Supplier
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/purchase/purchaseentry"
                                  ><h5 style="color: #29363dc2;">
                                    <i
                                      style="color: rgba(41, 54, 61, 0.76);"
                                      class="fa fa-plus"
                                    ></i>
                                    Purchase Entry
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/purchase/Listpurchesreturn"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-retweet"></i> Purchase
                                    Return
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/purchase/addpayment"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-money"></i> Add Payments
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/purchase/listpayment"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-retweet"></i> List Payments
                                  </h5></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </tab-content>

            <tab-content title="Sale" icon="fa fa-pie-chart">
              <div id="wrapper">
                <div id="container">
                  <ol class="organizational-chart">
                    <li>
                      <div class="opp">
                        <h4 style="color: #29363dc2;">
                          <i class="fa fa-pie-chart"></i> Sale
                        </h4>
                      </div>
                      <ol style="width: 42%; margin-left: 29%;">
                        <li>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/sales/Customeradd"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-user-plus"></i> Add Customer
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/sales/salesentry"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-cart-plus"></i> Sale Entry
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/Salesreturn/list">
                                  <h5 style="color: #29363dc2;">
                                    <i class="fa fa-retweet"></i> Sale Return
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/sales/saleinvoice/list"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-file-text-o"></i> Sale
                                    Invoice
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/sales/salereceipt"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-file"></i> Sale Receipt
                                  </h5></a
                                >
                              </div>
                            </li>
                            <li>
                              <div class="opp">
                                <a href="#/sales/Salesreceipthistory"
                                  ><h5 style="color: #29363dc2;">
                                    <i class="fa fa-file"></i> Sale Receipt
                                    History
                                  </h5></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </tab-content>

            <tab-content title="Stock Transfer" icon="fa fa-exchange">
              <div id="wrapper">
                <div id="container">
                  <ol class="organizational-chart">
                    <li>
                      <div class="opp">
                        <h4 style="color: #29363dc2;">
                          <i class="fa fa-exchange"></i> Stock Transfer
                        </h4>
                      </div>
                      <ol style="width: 42%; margin-left: 29%;">
                        <li>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/stocktransfer"
                                  ><h4 style="color: #29363dc2;">
                                    <i class="fa fa-retweet"></i> From Shop To
                                    Shop
                                  </h4></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </tab-content>

            <tab-content title="Shop Inventory" icon="fa fa-th-list">
              <div id="wrapper">
                <div id="container">
                  <ol class="organizational-chart">
                    <li>
                      <div class="opp">
                        <a href="#/shop_inventory">
                          <h4 style="color: #29363dc2;">Shop Inventory</h4></a
                        >
                      </div>
                      <ol style="width: 42%; margin-left: 29%;">
                        <li>
                          <ol>
                            <li>
                              <div class="opp">
                                <a href="#/shopinventory"
                                  ><h4 style="color: #29363dc2;">
                                    <i class="fa fa-retweet"></i> Shop Inventory
                                  </h4></a
                                >
                              </div>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "help2",
  components: {
    FormWizard,
    TabContent,
  },
  data: function () {
    return {
      loading: false,
    };
  },
  methods: {
    download_manual() {
      var _this = this;
      var access_token = localStorage.getItem("authUser");
      this.loading = true;
      var url1 =
        _this.baseURL2 +
        "/api/containers/common/download/I2OC_User_Manual.pdf?access_token=" +
        access_token;
      _this
        .$http({
          url: url1,
          method: "GET",
          responseType: "blob",
        })
        .then((res) => {
          // console.log(res)
          _this.loading = false;
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.setAttribute("download", "I2OC_User_Manual.pdf");
          link.href = url1;
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style type="text/css">
.finish-button {
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
}

.line {
  width: 1px;
  height: 100px;
  background-color: black;
  position: absolute;
}
.left_mar {
  margin-left: -12px;
}
.btn-primary {
  border-radius: 7px;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#container {
  float: left;
  padding: 1em;
  width: 100%; /*
    margin-left: 10%;
    margin-right: 10%;*/
}

ol.organizational-chart,
ol.organizational-chart ol,
ol.organizational-chart li,
ol.organizational-chart li > div {
  position: relative;
}

ol.organizational-chart,
ol.organizational-chart ol {
  list-style: none;
  margin: 0;
  padding: 0;
}

ol.organizational-chart {
  text-align: center;
}

ol.organizational-chart ol {
  padding-top: 1em;
}

ol.organizational-chart ol:before,
ol.organizational-chart ol:after,
ol.organizational-chart li:before,
ol.organizational-chart li:after,
ol.organizational-chart > li > div:before,
ol.organizational-chart > li > div:after {
  background-color: #ffc56c;
  content: "";
  position: absolute;
}

ol.organizational-chart ol > li {
  padding: 1em 0 0 1em;
}

ol.organizational-chart > li ol:before {
  height: 1em;
  left: 50%;
  top: 0;
  width: 3px;
}

ol.organizational-chart > li ol:after {
  height: 3px;
  left: 3px;
  top: 1em;
  width: 50%;
}

ol.organizational-chart > li ol > li:not(:last-of-type):before {
  height: 3px;
  left: 0;
  top: 2em;
  width: 1em;
}

ol.organizational-chart > li ol > li:not(:last-of-type):after {
  height: 100%;
  left: 0;
  top: 0;
  width: 3px;
}

ol.organizational-chart > li ol > li:last-of-type:before {
  height: 3px;
  left: 0;
  top: 2em;
  width: 1em;
}

ol.organizational-chart > li ol > li:last-of-type:after {
  height: 2em;
  left: 0;
  top: 0;
  width: 3px;
}

ol.organizational-chart li > div {
  background-color: #fff;
  border-radius: 3px;
  min-height: 2em;
  padding: 0.1em;
}

/*** PRIMARY ***/
ol.organizational-chart > li > div {
  background-color: #ffc56c;
  margin-right: 1em;
}

ol.organizational-chart > li > div:before {
  bottom: 2em;
  height: 3px;
  right: -1em;
  width: 1em;
}

ol.organizational-chart > li > div:first-of-type:after {
  bottom: 0;
  height: 2em;
  right: -1em;
  width: 3px;
}

ol.organizational-chart > li > div + div {
  margin-top: 1em;
}

ol.organizational-chart > li > div + div:after {
  height: calc(50% + 1em);
  right: -1em;
  top: -1em;
  width: 3px;
}

/*** SECONDARY ***/
ol.organizational-chart > li > ol:before {
  left: inherit;
  right: 0;
}

ol.organizational-chart > li > ol:after {
  left: 0;
  width: 100%;
}

ol.organizational-chart > li > ol > li > div {
  background-color: #90ccf4;
  color: #7b7575;
}

/*** TERTIARY ***/
ol.organizational-chart > li > ol > li > ol > li > div {
  background-color: #f78888;
  color: #7b7575;
}

/*** QUATERNARY ***/
ol.organizational-chart > li > ol > li > ol > li > ol > li > div {
  background-color: #fca858;
}

/*** QUINARY ***/
ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > div {
  background-color: #fddc32;
}

/*** MEDIA QUERIES ***/
@media only screen and (min-width: 64em) {
  ol.organizational-chart {
    margin-left: -1em;
    margin-right: -1em;
  }

  /* PRIMARY */
  ol.organizational-chart > li > div {
    display: inline-block;
    float: none;
    margin: 0 1em 1em 1em;
    vertical-align: bottom;
  }

  ol.organizational-chart > li > div:only-of-type {
    margin-bottom: 0;
    width: calc((25% / 1) - 2em - 4px);
  }

  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(2),
  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(2) ~ div {
    width: calc((35% / 2) - 2em - 4px);
  }

  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(3),
  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(3) ~ div {
    width: calc((35% / 3) - 2em - 4px);
  }

  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(4),
  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(4) ~ div {
    width: calc((35% / 4) - 2em - 4px);
  }

  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(5),
  ol.organizational-chart > li > div:first-of-type:nth-last-of-type(5) ~ div {
    width: calc((35% / 5) - 2em - 4px);
  }

  ol.organizational-chart > li > div:before,
  ol.organizational-chart > li > div:after {
    bottom: -1em !important;
    top: inherit !important;
  }

  ol.organizational-chart > li > div:before {
    height: 1em !important;
    left: 50% !important;
    width: 3px !important;
  }

  ol.organizational-chart > li > div:only-of-type:after {
    display: none;
  }

  ol.organizational-chart > li > div:first-of-type:not(:only-of-type):after,
  ol.organizational-chart > li > div:last-of-type:not(:only-of-type):after {
    bottom: -1em;
    height: 3px;
    width: calc(30% + 1em + 3px);
  }

  ol.organizational-chart > li > div:first-of-type:not(:only-of-type):after {
    left: calc(30% + 3px);
  }

  ol.organizational-chart > li > div:last-of-type:not(:only-of-type):after {
    left: calc(-1em - 3px);
  }

  ol.organizational-chart > li > div + div:not(:last-of-type):after {
    height: 3px;
    left: -2em;
    width: calc(30% + 4em);
  }

  /* SECONDARY */
  ol.organizational-chart > li > ol {
    display: flex;
    flex-wrap: nowrap;
  }

  ol.organizational-chart > li > ol:before,
  ol.organizational-chart > li > ol > li:before {
    height: 1em !important;
    left: 50% !important;
    top: 0 !important;
    width: 3px !important;
  }

  ol.organizational-chart > li > ol:after {
    display: none;
  }

  ol.organizational-chart > li > ol > li {
    flex-grow: 1;
    padding-left: 1em;
    padding-right: 1em;
    padding-top: 1em;
  }

  ol.organizational-chart > li > ol > li:only-of-type {
    padding-top: 0;
  }

  ol.organizational-chart > li > ol > li:only-of-type:before,
  ol.organizational-chart > li > ol > li:only-of-type:after {
    display: none;
  }

  ol.organizational-chart > li > ol > li:first-of-type:not(:only-of-type):after,
  ol.organizational-chart > li > ol > li:last-of-type:not(:only-of-type):after {
    height: 3px;
    top: 0;
    width: 50%;
  }

  ol.organizational-chart
    > li
    > ol
    > li:first-of-type:not(:only-of-type):after {
    left: 50%;
  }

  ol.organizational-chart > li > ol > li:last-of-type:not(:only-of-type):after {
    left: 0;
  }

  ol.organizational-chart > li > ol > li + li:not(:last-of-type):after {
    height: 3px;
    left: 0;
    top: 0;
    width: 100%;
  }
}

.opp {
  -webkit-box-shadow: 0 10px 6px -6px #777;
  -moz-box-shadow: 0 10px 6px -6px #777;
  box-shadow: 0 10px 6px -6px #777;
  color: #7b7575;
}

.wizard-tab-container {
  display: block;
  animation: fadeInRight 0.7s;
}
.wizard-header {
  display: none;
}
.vue-form-wizard .wizard-icon-circle {
  width: 50px !important;
  height: 50px !important;
}
.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  top: 32px;
  height: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/help.vue